
import styled from 'styled-components'

import NavigationBar from 'components/UI/NavigationBar/NavigationBar'
import './_feedNavbar.scss'
import { useUserProfile } from 'store'

interface FeedNavbarProps {
    listId: string
    setListId: (val: string) => void
}

const FeedNavbar = ({ setListId, listId }: FeedNavbarProps) => {
    const userData = useUserProfile()
    // const lists = userData?.selected_lists ?? [];

    const lists = (userData?.selected_lists ?? [])
    .filter(list => list.selected === 1)
    .sort((a, b) => (a.order ?? 999) - (b.order ?? 999))

    return (
        <FeedNav>
            <NavigationBar
                navArr={lists}
                type='light'
                customClass='feed'
                showManageFeed={true}
                listId={listId}
                setListId={setListId}
            />
        </FeedNav>
    )
}

const FeedNav = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 2rem;
    margin-top: 1.5rem;
    padding-left:1.5rem;
    padding-right:1.5rem;
`

export default FeedNavbar
